import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { contains } from 'ramda'
import { getLabel } from '../common/ambient'

export default class CheckboxList extends PureComponent {
  static propTypes = {
    allFields: PropTypes.array,
    activeFields: PropTypes.array,
    onChange: PropTypes.func,
    device: PropTypes.object
  };

  render() {
    const { allFields, activeFields, onChange, device } = this.props
    if (!allFields || allFields.length < 1) {
      return <div className="checkbox-list" />
    }
    const filteredActiveFields = activeFields.filter(field => contains(field, allFields))
    return (
      <div className="checkbox-list">
        <div className="btn-group">
          <button type="button" className="btn btn-circle btn-blue" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Filter{filteredActiveFields.length !== allFields.length && ` (${filteredActiveFields.length})`} <span className="caret"></span>
          </button>
        </div>
        <ul className="dropdown-menu filter">
          <li key="select-toggle" className="select-toggle">
            <a
              onClick={() => {
                if (onChange) {
                  if (filteredActiveFields.length === allFields.length) {
                    // Select None - pass empty array
                    onChange([])
                  } else {
                    // Select All - pass all fields
                    onChange(allFields)
                  }
                }
              }}
            >
              {filteredActiveFields.length === allFields.length ? 'Select None' : 'Select All'}
            </a>
          </li>
          {allFields.map((key) => {
            const isChecked = contains(key, activeFields)
            return (
              <li key={key}>
                <label>
                  <span>{getLabel(key, device)}</span>
                  <input
                    type="checkbox"
                    onChange={() => {
                      if (onChange) {
                        // Toggle this field in the active fields array
                        const newActiveFields = isChecked
                          ? activeFields.filter(field => field !== key)
                          : [...activeFields, key]
                        onChange(newActiveFields)
                      }
                    }}
                    checked={isChecked}
                  />
                </label>
              </li>
            )
          })}
        </ul>
      </div>
    );
  }
}

CheckboxList.displayName = 'CheckboxList'
